import React from 'react';

import { MfaManagementModalContent } from 'src/components/auth/MfaManagementModalContent';
import { Modal } from 'src/components/common';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export interface MfaManagementModalProps {
  userId: string;
}

export const MfaManagementModal: React.FC<ModalV2Props<MfaManagementModalProps>> = ({
  id,
  userId,
}) => {
  const { closeModal } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="User MFA Management"
      maxWidth={550}
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <MfaManagementModalContent userId={userId} onCloseModal={handleCloseModal} />
    </Modal>
  );
};
